"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntries = void 0;
/**
 * Object.entries that actually preserves entries as types.
 * @param o - The object to get the entries from
 * @returns The entries of the object preserving type
 */
function getEntries(o) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.entries(o);
}
exports.getEntries = getEntries;
//# sourceMappingURL=getEntries.js.map